import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Validate from '../lib/validate';
import Settings from '../lib/settings';
import * as Actions from '../actions';
import {connect} from 'react-redux';

class InfoUpdate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      _id: '',
      name: '',
      street: '',
      postalCode: '',
      city: '',
      ico: '',
      dic: '',
      tel: '',
      email: '',
      formMessage: [],
      canScroll: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    //this.addFormMessage = this.handleSubmit.bind(this);
  }

  componentDidMount() {

    //this.props.dispatch(Actions.loader(true));
    fetch('/api/info', Settings.fetchParams('GET')).then(res => res.json().then(json => {
      if (typeof json.info !== "undefined") {
        this.setState(json.info);
      }
    }));

    window.scrollTo(0, this.props.menuPosition);
  }

  componentDidUpdate() {
    //window.scrollTo(0, this.props.menuPosition);
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({editorState});
    //console.log(convertToRaw(this.state.editorState.getCurrentContent()));
  };

  addParameterValueForm() {
    this.setState(prevState => ({
      parameterValues: [
        ...prevState.parameterValues,
        ""
      ]
    }));
    //ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addWrongInputClass(name) {
    ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addFormMessage(message) {

    this.setState(prevState => ({
      formMessage: [
        ...prevState.formMessage,
        message
      ],
      canScroll: true
    }));
  }

  handleChange(event) {

    this.setState({
      [event.target.name]: event.target.value
    });
    ReactDOM.findDOMNode(this.refs[event.target.name]).classList.remove(Settings.wrongInput);
  }

  handleSubmit(event) {

    event.preventDefault();
    let errorCheck = true;

    this.setState({formMessage: []});

    if (!Validate.info(this.state.name, "name")) {
      this.addFormMessage("Vyplnťe název obchodu.");
      errorCheck = false;
      this.addWrongInputClass("name");
    }

    if (!Validate.info(this.state.street, "street")) {
      this.addFormMessage("Vyplnťe ulici obchodu.");
      errorCheck = false;
      this.addWrongInputClass("street");
    }

    if (!Validate.info(this.state.postalCode, "postalCode")) {
      this.addFormMessage("Vyplnťe PSČ obchodu.");
      errorCheck = false;
      this.addWrongInputClass("postalCode");
    }

    if (!Validate.info(this.state.city, "city")) {
      this.addFormMessage("Vyplnťe město obchodu.");
      errorCheck = false;
      this.addWrongInputClass("city");
    }

    if (!Validate.info(this.state.ico, "ico")) {
      this.addFormMessage("Vyplnťe IČO obchodu.");
      errorCheck = false;
      this.addWrongInputClass("ico");
    }

    if (!Validate.info(this.state.dic, "dic")) {
      this.addFormMessage("Vyplnťe DIČ obchodu.");
      errorCheck = false;
      this.addWrongInputClass("dic");
    }

    if (!Validate.info(this.state.tel, "tel")) {
      this.addFormMessage("Vyplnťe telefon do obchodu.");
      errorCheck = false;
      this.addWrongInputClass("tel");
    }

    if (!Validate.email(this.state.email)) {
      this.addFormMessage("Vyplnťe email do obchodu.");
      errorCheck = false;
      this.addWrongInputClass("email");
    }

    if (errorCheck) {

      //this.props.dispatch(Actions.loader(true));

      let info = {
        _id: this.state._id,
        name: this.state.name,
        street: this.state.street,
        postalCode: this.state.postalCode,
        city: this.state.city,
        ico: this.state.ico,
        dic: this.state.dic,
        tel: this.state.tel,
        email: this.state.email
      };

      if (Validate.info(info, "for_insert")) {

        var sucessText = "Změny uloženy!";

        fetch('/api/info', Settings.fetchParams('POST', info)).then(res => {
          this.props.dispatch(Actions.loader(false));
          if (res.ok) {
            res.json().then(json => {
              if (!json.error) {
                window.scrollTo(0, this.props.menuPosition);
                ReactDOM.findDOMNode(this.refs.addProduct).innerHTML = '<h2 class="addSuccess">' + sucessText + '</h2>';
              } else {
                console.log("Error");
              }
            })
          } else {
            alert("Error");
          }
        });

      } else {
        alert("Vyplňte korektně formulář..");
      }

    }

  }

  render() {

    const formErrorMessages = this.state.formMessage.map((item, index) => <p key={index}>{item}</p>);

    if (this.state.formMessage.length > 0 && this.state.canScroll) {
      window.scrollTo(0, this.props.menuPosition);
      this.setState({canScroll: false});
    }

    return (<div className="form">
      <div ref="addProduct">
        <h1>Provozovatel:</h1>

        <div className="formErrorMessages">
          {formErrorMessages}
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col50">
              <div className="formLabel">Název obchodu</div>
              <div className="formInput"><input type="text" ref="name" value={this.state.name} onChange={this.handleChange} name="name" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Ulice</div>
              <div className="formInput"><input type="text" ref="street" name="street" value={this.state.street} onChange={this.handleChange} required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Psč</div>
              <div className="formInput"><input type="text" ref="postalCode" value={this.state.postalCode} onChange={this.handleChange} name="postalCode" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Město</div>
              <div className="formInput"><input type="text" ref="city" name="city" value={this.state.city} onChange={this.handleChange} required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">IČO</div>
              <div className="formInput"><input type="text" ref="ico" value={this.state.ico} onChange={this.handleChange} name="ico" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">DIČ</div>
              <div className="formInput"><input type="text" ref="dic" name="dic" value={this.state.dic} onChange={this.handleChange} required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Telefon</div>
              <div className="formInput"><input type="text" ref="tel" value={this.state.tel} onChange={this.handleChange} name="tel" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Email</div>
              <div className="formInput"><input type="text" ref="email" name="email" value={this.state.email} onChange={this.handleChange} required="required"/></div>
            </div>

          </div>
        </form>

        <div className="col100">
          <button type="submit" onClick={this.handleSubmit}>Uložit</button>
        </div>
      </div>
    </div>);
  }
}
function mapStateToProps(state) {
  return {admin: state.admin, menuPosition: state.menuPosition};
}
export default connect(mapStateToProps)(InfoUpdate);



// WEBPACK FOOTER //
// ./src/pages/InfoUpdate.js